var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.74389 15.2558C6.64599 15.158 6.56832 15.0419 6.51533 14.9141C6.46233 14.7862 6.43506 14.6492 6.43506 14.5108C6.43506 14.3724 6.46233 14.2354 6.51533 14.1076C6.56832 13.9797 6.64599 13.8636 6.74389 13.7658L11.2909 9.20881C11.3838 9.11569 11.4941 9.0418 11.6156 8.99139C11.7371 8.94098 11.8674 8.91503 11.9989 8.91503C12.1304 8.91503 12.2607 8.94098 12.3822 8.99139C12.5036 9.0418 12.614 9.11569 12.7069 9.20881L17.2569 13.7668C17.4542 13.9641 17.5651 14.2318 17.5651 14.5108C17.5651 14.7899 17.4542 15.0575 17.2569 15.2548C17.0596 15.4521 16.7919 15.563 16.5129 15.563C16.2338 15.563 15.9662 15.4521 15.7689 15.2548L11.9989 11.4788L8.23089 15.2548C8.13329 15.3525 8.01738 15.43 7.88981 15.4829C7.76223 15.5358 7.62549 15.563 7.48739 15.563C7.34929 15.563 7.21255 15.5358 7.08498 15.4829C6.9574 15.43 6.8415 15.3525 6.74389 15.2548V15.2558Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.a258ab950130353bbfd93e2241ebc00c.svg";
export { ForwardRef as ReactComponent };